import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../config/rbac/actions.ts";
import {AddPage as AddAccountApplicationPage} from "../account-applications/pages/AddPage.tsx";

export const AccountsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListAccounts) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes(rbacActions.CreateAccount) ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/accounts'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetAccount) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/accounts'/>
                    )
                }
            />

            <Route
                path=':id/applications/add'
                element={
                    allowedActions.includes(rbacActions.CreateAccountApplication) ? (
                        <AddAccountApplicationPage/>
                    ) : (
                        <Navigate to='/accounts'/>
                    )
                }
            />

        </Routes>
    );
};
